import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { InternalDocumentDetail } from "core/http/service/internalDocument/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: InternalDocumentDetail | null;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getDocsDetailSlice = createSlice({
  name: "getDocsDetail",
  initialState,
  reducers: {
    getDocsDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getDocsDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getDocsDetailFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetDocsDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  getDocsDetailStart,
  getDocsDetailSuccess,
  getDocsDetailFailed,
  resetDocsDetail,
} = getDocsDetailSlice.actions;

export default getDocsDetailSlice.reducer;
